var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMagicSquareLogo = function SvgMagicSquareLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70.5",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M38.617 2.623c-2.933-2.83-7.691-2.83-10.626 0-2.935 2.83-2.935 7.416 0 10.246l20.102 19.384 4.726-4.558c3.259-3.141 3.259-8.237 0-11.38L38.617 2.623Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m20.412 11.325 39.272 38.463-10.832 10.609L9.579 21.934l10.832-10.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m20.426 38.747 20.112 18.99a7.455 7.455 0 0 1 0 10.573c-2.93 2.92-7.683 2.92-10.615 0L15.705 53.995c-3.256-3.243-3.256-7.302 0-10.545l4.721-4.703Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M67.843 29.39a7.299 7.299 0 0 0-10.422 0c-2.877 2.918-2.877 7.648 0 10.567l5.21 5.285 5.212-5.285c2.876-2.919 2.876-7.649 0-10.568Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m7.369 25.758 5.21 5.283c2.877 2.92 2.877 7.65 0 10.569a7.295 7.295 0 0 1-10.421 0c-2.877-2.92-2.877-7.65 0-10.569l5.21-5.283Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 49.918,
    x2: 14.217,
    y1: 13.484,
    y2: 53.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F170A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#D561CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBFFA"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMagicSquareLogo);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";